// Set to actual show starting time ('June 27, 2020 20:00:00 GMT+2')
const showStartingTimeString = 'June 27, 2020 20:00:00 GMT+2';

export default new Date(showStartingTimeString);
